<template>
  <div>
    <label v-if="label !== null && label !== ''">{{ label }}</label>
    <div :class="['check', { 'check--active' : checked }, { 'check--custom-text' : customText }, getTheme]">
      <div class="check__circle" @click="onClick" @keyup.enter="onClick" tabindex="0"></div>
      <slot />
      <input type="hidden" :id="id" :name="name" :value="val" />
    </div>
    <div class="nt-form-error" v-if="error">{{ error }}</div>
  </div>
</template>

<script>
import _ from 'lodash'
import { eventBus } from '../../../eventBus'

export default {
  name: 'nt-checklink-weblead',
  props: {
    id: {
      type: String
    },
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: null
    },
    dataSource: {
      type: Object,
      required: true,
      validator(val) {
        return Object.hasOwnProperty.call(val, 'Value')
      }
    },
    validators: {
      type: Array,
      default: []
    },
    theme: {
      type: String,
      default: 'default'
    },
    customText: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      checked: false,
      error: null,
      val: null,
    }
  },
  computed: {
    getTheme() {
      return `check--${this.theme}`
    },
    hasLink() {
      return !!this.dataSource.Url
    },
    hasText() {
      return !!this.dataSource.Text
    }
  },
  watch: {
    '$parent.errors': function (values) {
      this.error = _.values(_.find(values, this.id, _.first))[0]
    }
  },
  created() {
    const { formData, validators } = this.$parent.$data
    // Add to form initial values
    Object.assign(formData, {
      [this.id]: this.checked ? this.dataSource.Value : null
    })
    // Add validators to form
    Object.assign(validators, {
      [this.id]: this.validators
    })
  },
  methods: {
    onEnter() {
      event.stopPropagation()
      window.open(this.dataSource.Url, '_blank')
    },
    onClick() {
      this.checked = !this.checked
      this.changeForm()
    },
    changeForm() {
      this.val = this.checked ? this.dataSource.Value : null
      eventBus.$emit('checkLinkWebleadClick', this.id)
      this.$parent.$emit('changeForm', {
        [this.id]: this.val
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .check {
    $container: &;
    display: flex;
    align-items: flex-start;

    &:hover {
      cursor: auto;
    }

    &__circle {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 18px;
      height: 18px;
      min-width: 18px;
      padding: 2px;
      margin-right: 10px;
      border: 1px solid #CCC;
      cursor: pointer;
    }

    & a {
      font-size: 18px;
      line-height: 18px;
    }

    &__text {
      font-size: 18px;
      line-height: 18px;
      letter-spacing: -1px;
      color: rgb(62, 59, 55);
      // white-space: nowrap;
      text-decoration: none;

      &--margin {
        &:not(:last-child) {
          margin-right: 15px;
        }
      }

      &-link {
        &:hover {
          text-decoration: underline;
        }
      }
    }

    &--active {
      #{$container}__circle {
        &::before {
          content: '';
          width: 100%;
          height: 100%;
          background: #9ddda9;
        }
      }
    }

    &--small {
      #{$container}__circle {
        width: 16px;
        height: 16px;
        min-width: 16px;
      }

      a {
        font-size: 16px;
        line-height: 16px;
      }

      #{$container}__text {
        font-size: 16px;
        line-height: 16px;
      }
    }
     
    &--custom-text {
      & .links {
        // font-size: 16px;
        line-height: 16px;
      }
      & a {
        letter-spacing: -1px;
        color: rgb(62, 59, 55);
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }
      #{$container}__text {
        display: none;
      }
    }
  }
</style>

